import { FilterListGlobalForm } from 'common/pages/filter-list-global/FilterListGlobalForm.tsx'

export const FilterListGlobalFormAgency = (props: any) => <FilterListGlobalForm {...props} mode={props.mode} agency />
